import React, { useEffect, useRef, useState } from "react";
import {
  ActionIcon,
  Anchor,
  Button,
  Modal,
  Progress,
  Text,
  Loader,
  Center,
} from "@mantine/core";
import flat from "flat";
import { BeatLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import { loadingStates, validateEmail } from "../../utilities/utilities";
import colors from "../../utilities/design";
import { showNotification } from "@mantine/notifications";
import Editor from "../../components/Editor";
import TemplatesList from "../../components/TemplateManager/TemplatesList";
import {
  getTemplateEditorField,
  templatesDetailsApi,
} from "../../utilities/apis/templates";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import { selectUserData } from "../../redux/selectors";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  createEditorField,
  getDocsToken,
  getEditorField,
  uploadFromLocal,
} from "../../utilities/apis/agreements";
import TaskNewForm from "../../components/CaseNewUI/TaskNewForm";
import { selectAgreementWorkFlow } from "../../redux/selectors";
import { agreementTranSaveApi } from "../../utilities/apis/agreements";
import { IconArrowLeft } from "@tabler/icons-react";
import { Trash } from "tabler-icons-react";
import constants from "../../utilities/constants";
import { Group, ThemeIcon, Title, Divider, Paper } from "@mantine/core";
import { getLink } from "../../utilities/apis/googleDocs";
import { IconFileText, IconX } from "@tabler/icons-react";

const AgreementForm4 = ({ id, form, setUiConfigs, uiConfigs, save }) => {
  const agreementFormJson = flat.unflatten(form.values);
  const slctAgreementWorkFlow = useSelector(selectAgreementWorkFlow) || [];
  console.log("Form values after user involved:", form.values);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentUser = useSelector(selectUserData) || {};
  const editorRef = useRef();

  const [modal, setModal] = useState(false);
  const [screen, setScreen] = useState(1);
  const [placeholders, setPlaceholders] = useState([]);
  const [errors, setErrors] = useState({});

  const [configs, setConfigs] = useState({
    templateView: false,
    templateId: null,
    editorContent: {
      content: "agreement content goes here...",
    },
    templateField: "",
  });
  const [tasksConfig, setTasksConfig] = useState({
    reviweFormVisible: false,
    taskFormVisible: false,
    loading: loadingStates.NO_ACTIVE_REQUEST,
    tasks: [],
    page: 1,
    tasksCount: null,
    loadTask: null,
    loadRemark: null,
    completionFlagBtnLoading: false,
  });
  const [locked, setLocked] = useState(true);
  const [show, setShow] = useState();
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [docData, setDocData] = useState(null);
  const [loadingEditor, setLoadingEditor] = useState(false);

  console.log("selected file:", selectedFile);

  const getTemplateField = async (templateId) => {
    const formData = {
      templateId,
    };
    console.log("first function called");
    // const res = await apiWrapWithErrorWithData(templatesDetailsApi({templateId: templateId}));

    // console.log("response for template details: ", res);
    // setConfigs({...configs, editorContent: res.template.quillDelta});
    const response = await apiWrapWithErrorWithData(
      getTemplateEditorField(formData),
    );
    if (response.success) {
      setConfigs((prevState) => ({
        ...prevState,
        templateField: response?.getFieldName?.fieldName,
      }));
      console.log("template fields: ", response?.getFieldName?.fieldName);
      saveAgreementInputField(response?.getFieldName?.fieldName);
    } else {
      // showNotification({
      //   color: "red",
      //   title: "Editor Field",
      //   message: "Something went wrong.",
      // });
    }
  };

  const getLinkApi = async () => {
    try {
      const response = await apiWrapWithErrorWithData(
        getLink({ agreementId: id }),
      );

      if (response.success) {
        setDocData(response.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const loadDocumentIntoEditor = async () => {
    try {
      setLoadingEditor(true);

      const accessToken = await apiWrapWithErrorWithData(getDocsToken());

      const graphResponse = await fetch(
        `https://graph.microsoft.com/v1.0/users/${constants.userId}/drive/items/${docData.documentId}/content`,
        {
          headers: {
            Authorization: `Bearer ${accessToken.data}`,
          },
        },
      );

      if (!graphResponse.ok) throw new Error("Unable to download document.");

      const blob = await graphResponse.blob();

      const file = new File([blob], `${docData.title || "Agreement"}.docx`, {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      console.log("Template size:", file.size);

      if (file.size > 50 * 1024 * 1024) {
        throw new Error("Template exceeds the maximum supported size.");
      }

      const formData = new FormData();

      formData.append("file", file);

      const sfdtResponse = await fetch(
        `${constants.wordeditorApi}/api/documenteditor/Import`,
        {
          method: "POST",
          body: formData,
        },
      );

      if (!sfdtResponse.ok) {
        const errorText = await sfdtResponse.text();

        console.error("Import API Error:", {
          status: sfdtResponse.status,
          body: errorText,
        });

        throw new Error(`Document Import failed (${sfdtResponse.status})`);
      }

      const response = await sfdtResponse.json();

      console.log("Import response:", response);

      if (response?.sfdt || response?.sections) {
        setSfdtContent(response);
        return;
      }

      throw new Error("Invalid Import API response.");
      throw new Error("Import API returned an invalid response.");
    } catch (e) {
      showNotification({
        color: "red",
        title: "Editor Error",
        message: e.message,
      });
    } finally {
      setLoadingEditor(false);
    }
  };

  const saveAgreementInputField = async (inputField) => {
    console.log("input fields for agrement: ", inputField);
    const formData = {
      fieldName: [...new Set(inputField)],
      agreementId: id,
    };
    const response = await apiWrapWithErrorWithData(
      createEditorField(formData),
    );

    if (response?.success) {
      console.log(response.success);
    } else {
      // showNotification({
      //   message: "Error in saving Editor Field.",
      //   title: "Editor Field",
      //   color: "red",
      // });
    }
  };

  const savePrev = async () => {
    setUiConfigs({
      ...uiConfigs,
      currentStep: 3,
    });
  };

  // const localSave = async () => {
  //   if (selectedFile) {
  //     await save({
  //       ...form.values,
  //       contractQuillJsDelta: configs.editorContent,
  //       //contractQuillJsDelta:{
  //       //  ops: [{ insert: cntt }],
  //       //},
  //       formCompleted: true,
  //     });
  //     const formData = new FormData();
  //     const file = selectedFile;
  //     formData.append("file", file);
  //     try {
  //       const response = await uploadFromLocal({
  //         agreementId: id,
  //         formData: formData,
  //       });
  //       console.log("response: ", response);
  //       showNotification({
  //         title: "upload from local",
  //         message: "content uploaded",
  //         color: "green",
  //       });
  //       navigate("/app/agreements_manager/agreements/details/" + id);
  //     } catch (error) {
  //       console.log("error: ", error);
  //       showNotification({
  //         title: "upload from local",
  //         message: "couldnot upload ",
  //         color: "red",
  //       });
  //     }
  //   } else {
  //     showNotification({
  //       title: "error",
  //       message: "please select a file before finish",
  //       color: "red",
  //     });
  //   }
  // };

  const saveNext = async () => {
    setErrors({});
    setLoading(true);
    if (selectedFile) {
      await save({
        ...form.values,

        formCompleted: true,
      });

      const formData = new FormData();
      const file = selectedFile;
      formData.append("file", file);
      try {
        const response = await uploadFromLocal({
          agreementId: id,
          formData: formData,
        });
        console.log("response: ", response);
        showNotification({
          title: "upload from local",
          message: "content uploaded",
          color: "green",
        });
        setLoading(false);
        navigate("/app/agreements_manager/agreements/details/" + id);
      } catch (error) {
        console.log("error: ", error);
        setLoading(false);
        showNotification({
          title: "upload from local",
          message: "couldnot upload ",
          color: "red",
        });
      }
    } else {
      setLoading(true);

      if (!editorRef.current) {
        console.warn(
          "saveNext: editorRef.current falsy on PRE-save check.",
          { loadingEditor, hasSfdtContent: !!sfdtContent },
        );
        showNotification({
          color: "red",
          title: "Editor",
          message: "Editor is still loading. (pre-save check)",
        });
        return;
      }

      const latestSfdt = editorRef.current.getSfdt();

      if (!latestSfdt) {
        showNotification({
          color: "red",
          title: "Document",
          message: "Editor content is not ready.",
        });
        return;
      }

      const blob = await editorRef.current.saveDocument();
      const savedAgreementId = await save({
        ...form.values,

        contractQuillJsDelta: latestSfdt,

        formCompleted: true,
      });
      const agreementIdForUpload =
        typeof savedAgreementId === "number" || typeof savedAgreementId === "string"
          ? savedAgreementId
          : id;

      const formData = new FormData();
      formData.append("file", blob, "MyDocument.docx");
      try {
        const response = await uploadFromLocal({
          agreementId: agreementIdForUpload,
          formData: formData,
        });
        console.log("response: ", response);
        showNotification({
          title: "upload from local",
          message: "content uploaded",
          color: "green",
        });
        setLoading(false);
        navigate(
          "/app/agreements_manager/agreements/details/" +
            agreementIdForUpload,
        );
      } catch (error) {
        console.log("error: ", error);
        setLoading(false);
        showNotification({
          title: "upload from local",
          message: "couldnot upload ",
          color: "red",
        });
      }
    }
  };

  const [sfdtContent, setSfdtContent] = useState(null);
  const getTemplate = async () => {
    // setTemplatesConfig((prevState) => ({
    //   ...prevState,
    //   loading: loadingStates.LOADING,
    // }));
    const response = await apiWrapWithErrorWithData(
      templatesDetailsApi({ templateId: configs.templateId }),
    );
    if (response?.success && response?.template) {
      const accessToken = await apiWrapWithErrorWithData(getDocsToken());

      const response2 = await fetch(
        `https://graph.microsoft.com/v1.0/users/${constants.userId}/drive/items/${response.template.quillDelta}/content`,
        {
          headers: {
            Authorization: `Bearer ${accessToken.data}`,
          },
        },
      );

      if (!response2.ok) {
        throw new Error("Unable to download template from SharePoint.");
      }

      const blob = await response2.blob();

      if (!blob || blob.size === 0) {
        throw new Error("Downloaded template is empty.");
      }

      const file = new File([blob], "doc.docx", {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      console.log("Template size:", file.size);

      if (file.size > 50 * 1024 * 1024) {
        throw new Error("Template exceeds the maximum supported size.");
      }

      const formData = new FormData();
      formData.append("file", file);

      const sfdtResponse = await fetch(
        `${constants.wordeditorApi}/api/documenteditor/Import`,
        { method: "POST", body: formData },
      );

      if (!sfdtResponse.ok) {
        const error = await sfdtResponse.text();

        console.error(error);

        throw new Error(`Import API failed (${sfdtResponse.status})`);
      }

      const responseSfdt = await sfdtResponse.json();

      console.log("Import response:", responseSfdt);

      if (responseSfdt?.sfdt || responseSfdt?.sections) {
        setSfdtContent(responseSfdt);
        return;
      }

      throw new Error("Invalid Import API response.");

      throw new Error("Import API returned an invalid response.");
      // setTemplatesConfig({
      //   ...templatesConfig,
      //   loading: loadingStates.NO_ACTIVE_REQUEST,
      //   editorContent: response.template.quillDelta,
      //   templateTitle: response.template.name,
      // });
      saveAgreementInputField(response.template.fieldName || []);
    } else {
      // showNotification({
      //   color: "red",
      //   title: "Templates Details",
      //   message: "Failed to load template details.",
      // });
      // setTemplatesConfig({
      //   ...templatesConfig,
      //   loading: loadingStates.NO_ACTIVE_REQUEST,
      // });
    }
  };

  useEffect(() => {
    if (configs.templateId) {
      // getTemplateField(configs.templateId);
      getTemplate();
    }
  }, [configs.templateId]);

  const handleSaveDisplay = () => {
    var crntStatusCheck2 = false;

    slctAgreementWorkFlow?.map((ele) => {
      if (
        ele.crntStatus === "draft" &&
        (currentUser.loginAs.id === 3 || currentUser.loginAs.id === 4)
      ) {
        //  console.log("inside");
        //  console.log(currentUser.loginAs.id);
        //  console.log(ele.crntStatus);
        crntStatusCheck2 = true;
      }
    });
    return crntStatusCheck2;
  };
  const handleSendForReviewDisplay = () => {
    var crntStatusCheck2 = false;

    slctAgreementWorkFlow?.map((ele) => {
      if (
        ele.crntStatus === "send_to_reviewer" &&
        (currentUser.loginAs.id === 3 || currentUser.loginAs.id === 4)
      ) {
        // console.log("inside");
        // console.log(currentUser.loginAs.id);
        // console.log(ele.crntStatus);
        crntStatusCheck2 = true;
      }
    });
    return crntStatusCheck2;
  };

  const handleSendForApprovalDisplay = () => {
    var crntStatusCheck2 = false;

    slctAgreementWorkFlow?.map((ele) => {
      if (
        ele.crntStatus === "send_to_approver" &&
        currentUser.loginAs.id === 4
      ) {
        // console.log("inside");
        // console.log(currentUser.loginAs.id);
        // console.log(ele.crntStatus);
        crntStatusCheck2 = true;
      }
    });
    return crntStatusCheck2;
  };

  const handleSendForSignatureDisplay = () => {
    var crntStatusCheck2 = false;

    slctAgreementWorkFlow?.map((ele) => {
      if (
        ele.crntStatus === "send_to_signauth" &&
        currentUser.loginAs.id === 5
      ) {
        //  console.log("inside");
        //  console.log(currentUser.loginAs.id);
        //  console.log(ele.crntStatus);
        //  flowId = ele.id
        crntStatusCheck2 = true;
      }
    });
    return crntStatusCheck2;
  };

  const handleButtonClickSave = async () => {
    //console.log("here");
    var flow_id = null;

    slctAgreementWorkFlow?.map((ele) => {
      if (
        ele.crntStatus === "draft" &&
        (currentUser.loginAs.id === 3 || currentUser.loginAs.id === 4)
      ) {
        flow_id = ele.id;
      }
    });

    const agreementTran = { flowId: flow_id, agreementId: id };

    //console.log(agreementTran);

    const { data } = await agreementTranSaveApi(agreementTran);
    //console.log("Response", data);

    if (data?.success) {
      showNotification({
        title: "Success",
        message: "Contract data saved successfully",
        color: "green",
      });
    } else {
      showNotification({
        title: "Error",
        message: "Failed to save contract data",
        color: "red",
      });
    }
  };

  useEffect(() => {
    if (!id) return;

    if (configs.templateId) return;

    getLinkApi();
  }, [id]);

  useEffect(() => {
    if (!docData?.documentId) return;

    loadDocumentIntoEditor();
  }, [docData]);

  useEffect(() => {
    if (selectedFile !== null) {
      setShow(false);
    } else {
      setShow(true);
    }
  }, [selectedFile]);

  // If the user hasn't uploaded a file or picked a template, show a blank
  // editor with default content to start typing into, instead of a dead
  // "No document loaded" placeholder. Guarded so it only initializes once
  // rather than wiping the user's in-progress typing on every re-render.
  const blankDocInitializedRef = useRef(false);
  useEffect(() => {
    if (loadingEditor || sfdtContent || selectedFile || configs.templateId) {
      return;
    }
    if (blankDocInitializedRef.current) return;
    blankDocInitializedRef.current = true;

    requestAnimationFrame(() => {
      editorRef.current?.createBlankDocument();
    });
  }, [loadingEditor, sfdtContent, selectedFile, configs.templateId]);
  //console.log("configs: ", configs);

  return (
    <>
      {/* {screen === 0 && (
        <>
          <div className="flex justify-center">
            <div className=" mt-10">
              <Button onClick={() => setScreen(2)} className=" my-4 block">
                upload from local
              </Button>
              <Button className="my-4 block" onClick={() => setScreen(1)}>
                choose a template
              </Button>
            </div>
          </div>
        </>
      )} */}

      <div className="w-full max-w-10/12 my-4 px-8">
        <Group justify="space-between" mb="xl">
          <Group gap="md">
            <ThemeIcon radius="xl" variant="light" size={44}>
              <IconFileText size={20} />
            </ThemeIcon>

            <div>
              <Title order={4}>Contract Content</Title>

              <Text size="sm" c="dimmed">
                Upload a DOCX file or generate the contract using a template.
              </Text>
            </div>
          </Group>
        </Group>

        <Divider mb="xl" />
        <div>
          <div className="w-full mt-4">
            <Paper withBorder radius="lg" shadow="xs" p="xl">
              {selectedFile === null ? (
                <div className="flex items-center justify-center  m-4">
                  <label
                    htmlFor="dropzone-file"
                    className="
                        flex flex-col
                        items-center
                        justify-center
                        w-full
                        h-64
                        border-2
                        border-dashed
                        border-blue-300
                        rounded-xl
                        bg-blue-50
                        hover:bg-blue-100
                        cursor-pointer
                        transition
                        shadow-sm
                      "
                  >
                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                      <svg
                        className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 16"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                        />
                      </svg>
                      <p
                        className="mb-2 text-sm text-gray-500 dark:text-gray-400"
                        style={{ textTransform: "none" }}
                      >
                        <span>Drag & drop your DOCX file here</span>&nbsp;or
                        click to browse
                      </p>
                      <p
                        className="text-xs text-gray-500 dark:text-gray-400"
                        style={{ textTransform: "none" }}
                      >
                        Upload Contract (.docx)
                      </p>
                    </div>
                    <input
                      onChange={(e) => {
                        setSelectedFile(e.target.files[0]);

                        setErrors((prev) => ({
                          ...prev,
                          document: undefined,
                        }));
                      }}
                      id="dropzone-file"
                      type="file"
                      accept=".docx"
                      className="hidden"
                    />
                  </label>
                </div>
              ) : (
                <Paper withBorder radius="lg" shadow="xs" p="md">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-4">
                      <img
                        src="/assets/images/downloadFileLogo.svg"
                        width={38}
                      />
                      <div>
                        <Text fw={600}>{selectedFile.name}</Text>
                        <Text size="xs" c="dimmed">
                          DOCX Document
                        </Text>
                      </div>
                    </div>

                    <ActionIcon
                      color="red"
                      variant="subtle"
                      onClick={() => setSelectedFile(null)}
                    >
                      <Trash size={18} />
                    </ActionIcon>
                  </div>

                  <Progress mt="md" radius="xl" value={100} />
                </Paper>
              )}
            </Paper>
          </div>
        </div>

        {errors.document && (
          <Text
            size="sm"
            mt="xs"
            style={{ textTransform: "none", color: "red" }}
          >
            {errors.document}
          </Text>
        )}
      </div>
      {show && (
        <>
          <Divider my={40} label="OR" labelPosition="center" />
          {configs.templateView && (
            <Modal
              centered
              size="80rem"
              withCloseButton
              centered
              radius="xl"
              padding={20}
              overlayOpacity={0.45}
              overlayBlur={2}
              styles={{
                content: {
                  overflow: "hidden",
                  borderRadius: 16,
                },
                body: {
                  padding: 10,
                  height: "85vh",
                  display: "flex",
                  flexDirection: "column",
                },
              }}
              opened={configs.templateView}
              onClose={() =>
                setConfigs((prev) => ({
                  ...prev,
                  templateView: false,
                }))
              }
              title={
                <div>
                  <Title order={2}>Contract Templates</Title>
                  <Text size="sm" c="dimmed">
                    Browse and select an existing template.
                  </Text>
                </div>
              }
            >
              <div
                style={{
                  padding: 0,
                }}
              >
                <TemplatesList
                  showNewTemplateBtn={false}
                  templateType="Agreements"
                  placeholders={placeholders}
                  setPlaceholders={setPlaceholders}
                  useTemplateFunc={(template) => {
                    setConfigs((prev) => ({
                      ...prev,
                      templateView: false,
                      templateId: template.id,
                    }));
                  }}
                />
              </div>
            </Modal>
          )}
          {tasksConfig.taskFormVisible && (
            <Modal
              closeOnClickOutside={false}
              overflow="inside"
              opened
              onClose={() => {
                setTasksConfig({
                  ...tasksConfig,
                  taskFormVisible: false,
                });
              }}
              size="calc(80vw)"
            >
              <TaskNewForm
                onModalExit={() => {
                  setTasksConfig({
                    ...tasksConfig,
                    taskFormVisible: false,
                  });
                }}
              />
            </Modal>
          )}
          <div className="w-full flex flex-col ">
            <div className="flex justify-end">
              <div className="flex justify-center">
                <Button
                  radius="md"
                  variant="contained"
                  size="md"
                  mb="lg"
                  onClick={() => {
                    setConfigs((prevState) => ({
                      ...prevState,
                      templateView: true,
                    }));
                  }}
                >
                  Choose Template
                </Button>
              </div>
            </div>

            <div className="w-full">
              <div
                style={{
                  width: "100%",
                }}
              >
                {loadingEditor ? (
                  <Center h={700}>
                    <Loader />
                  </Center>
                ) : (
                  <Editor
                    ref={editorRef}
                    initialContent={sfdtContent}
                    placeholders={placeholders}
                    setPlaceholders={setPlaceholders}
                    disabled={true}
                    editNotAllowed={false}
                  />
                )}
              </div>
            </div>

            {modal && (
              <Modal
                overflow="inside"
                opened
                onClose={() => {
                  setTasksConfig({
                    ...tasksConfig,
                    loadTask: null,
                  });
                }}
                size="calc(80vw)"
              >
                {/* <TaskDetailsUI
             title={title}
             parent={parent}
             parentId={parentId}
             taskId={tasksConfig.loadTask}
             onModalExit={() => {
               setTasksConfig({
                 ...tasksConfig,
                 loadTask: null,
               });
             }}
           /> */}
              </Modal>
            )}
          </div>
        </>
      )}
      <div
        style={{
          borderTop: "1px solid #E9ECEF",
          marginTop: 40,
          paddingTop: 24,
        }}
        className="flex justify-between items-center"
      >
        {loading ? (
          <BeatLoader color={colors.primary} size={10} />
        ) : (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Button variant="outline" radius="md" onClick={savePrev}>
                Previous
              </Button>

              <Button
                radius="md"
                px={30}
                loading={loading}
                disabled={loadingEditor}
                onClick={saveNext}
              >
                Finish
              </Button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AgreementForm4;
